export default __webpack_public_path__ + "static/media/Ventilatie.9a10ac3c.svg";